import { render, staticRenderFns } from "./FormNew.vue?vue&type=template&id=8b72f5ac&scoped=true&"
import script from "./FormNew.vue?vue&type=script&lang=js&"
export * from "./FormNew.vue?vue&type=script&lang=js&"
import style0 from "./FormNew.vue?vue&type=style&index=0&id=8b72f5ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b72f5ac",
  null
  
)

export default component.exports